<template>
  <div class="dimension">
    <header>
      <div class="header">
        <div class="header_left">
          <img src="../../assets/go_back.png" @click="toHome" />
          <span>3D模型</span>
        </div>
        <div class="header_right">
          <div class="header_box">
            <!-- 搜索栏 -->
            <div class="box_seach">
              <el-select v-model="value" size="small">
                <el-option value="1" label="应用" />
                <el-option value="2" label="字体" />
                <el-option value="3" label="动画" />
                <el-option value="4" label="视频" />
                <el-option value="5" label="音频" />
                <el-option value="6" label="3D模型" />
                <el-option value="7" label="音效" />
              </el-select>
              <input type="text" v-model="keyword" placeholder="搜索" />
              <div class="button" @click="search">搜索</div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- 内容部分 -->
    <div class="cont">
      <div class="type">
        <div
          class="item"
          v-for="(item, index) in typeList"
          :key="index"
          @click="changeType(index)"
        >
          <span :class="[item.selected == true ? 'active' : 'un_active']">{{
            item.name
          }}</span>
        </div>
      </div>
      <div v-if="lists.length > 0" class="list">
        <div
          class="list_item"
          v-for="(items, indexs) in lists"
          :key="indexs"
          @click="toDetail(6, items.product_id)"
        >
          <div class="pic">
            <img v-lazy="items.image" />
            <!-- <el-image :src="items.image" fit="fill"></el-image> -->
          </div>
          <div class="msg">
            {{ items.title }}
          </div>
        </div>
      </div>
      <div v-else class="empty_style">
        <el-image :src="require('../../assets/empty.png')"></el-image
        ><span>暂无数据</span>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[18, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getList, getCategoryByType } from '../../api/index'

export default {
  data () {
    return {
      value: '6',
      keyword: '',
      page: 1,
      pageSize: 8,
      total: 0,
      // 类型数据
      typeList: [],
      // 图片数据
      lists: [],
      hotSeach: [
        {
          name: '热门'
        },
        {
          name: '办公'
        },
        {
          name: '自然'
        },
        {
          name: '娱乐'
        }
      ], // 热门搜索数据

      params: { // 获取参数
        menuId: this.$route.query.menus_id, categoryId: this.$route.query.category_id
      }
    }
  },
  created () {
    this.getCategory()
  },
  methods: {
    // 获取分类
    getCategory () {
      getCategoryByType({ type: 6 }, res => {
        if (res.status === 'success') {
          this.typeList = res.result.data
          this.typeList.forEach(item => {
            this.$set(item, 'selected', false)
          })
          this.typeList[0].selected = true
        }
        this.params.menuId = this.typeList[0].id
        // this.params.categoryId = null
        this.getLists()
      })
    },
    // 获取数据
    getLists () {
      getList({ offset: (this.page - 1) * this.pageSize, length: this.pageSize, type: 6, menus_id: this.params.menuId, category_id: this.params.categoryId }, res => {
        this.lists = res.result.data
        this.total = res.result.total
        this.lists.forEach((item, index) => {
          this.lists[index].image = this.$imageUrl + item.image
        })
      })
    },
    // 跳转详情页
    toDetail (type, id) {
      this.$router.push({ path: '/product_detail', query: { type: type, product_id: id } })
    },
    // 前往首页
    toHome () {
      this.$router.push({ path: '/' })
    },
    // 搜索
    search () {
      this.$router.push({ path: '/search?keyword=' + this.keyword + '&type=' + this.value })
    },
    // 点击热门搜索
    hotClick (val) {
      this.keyword = val
      setTimeout(() => {
        this.$router.push({ path: '/search?keyword=' + val + '&type=' + this.value })
      })
    },
    // 选择类型
    changeType (index) {
      this.typeList.forEach((item, index) => {
        this.typeList[index].selected = false
      })
      this.typeList[index].selected = true
      this.params.menuId = this.typeList[index].id
      this.params.categoryId = null
      this.getLists()
    },

    // 分页
    handleSizeChange (e) {
      this.pageSize = e
      this.getLists()
    },
    handleCurrentChange (e) {
      this.page = e
      this.getLists()
    }
  }
}
</script>

<style lang="scss" scoped>
.dimension {
  width: 100%;
  min-width: 864px;
  min-height: 100vh;
  background-color: #eee;
  .big_cont {
    width: 100%;
    min-width: 1500px;
  }
  header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 140px;
    background-color: #ffffff;
    .header {
      width: 90%;
      margin: 0 auto;
      height: 140px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .header_left {
        width: 140px;
        height: 140px;
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          text-align: center;
          cursor: pointer;
        }
        span {
          margin-left: 20px;
          font-size: 18px;
          font-weight: 600;
        }
      }
      .header_right {
        width: 520px;
        height: 120px;
        display: flex;
        align-items: center;
        position: relative;
        .header_box {
          width: 520px;
          box-sizing: border-box;
          .box_seach {
            width: 520px;
            height: 41px;
            background-color: #fff;
            border-radius: 6px;
            border: 2px solid #0493fe;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            input {
              flex: 1;
              height: 30px;
              font-size: 14px;
              border: none;
              outline: none;
              color: #666;
            }
            .button {
              width: 70px;
              height: 38px;
              line-height: 38px;
              text-align: center;
              margin-right: -1px;
              background-color: #0493fe;
              color: #ffffff;
              cursor: pointer;
              user-select: none;
              font-size: 15px;
              z-index: 999;
            }
          }
        }
      }
    }
  }
  .cont {
    width: 100%;
    padding-bottom: 20px;
    .type {
      width: 100%;
      display: flex;
      // justify-content: space-around;
      align-items: center;
      height: 50px;
      background-color: #fff;
      .item {
        margin: 0 50px 0 50px;
      }
      .item:hover span {
        color: #0493fe;
        cursor: pointer;
      }
      .active {
        color: #0493fe;
      }
      .un_active {
        color: #666;
      }
    }
    .recommend {
      margin-top: 20px;
      display: flex;
      align-items: flex-end;
      span {
        margin-right: 20px;
        color: #999;
      }
    }
    .list {
      margin-top: 20px;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .list_item {
        position: relative;
        margin-bottom: 20px;
        width: 32%;
        margin-right: 2%;
        background-color: #fff;
        .pic {
          padding: 5px;
          box-sizing: border-box;
          width: 100%;
          height: 190px;
          overflow: hidden;
          display: flex;
          align-items: center;
          img {
            width: 100%;
          }
        }
      }
      .list_item:nth-child(3n + 3) {
        margin-right: 0;
      }
      .list_item:hover {
        cursor: pointer;
        box-shadow: 0 0 9px 3px #ccc;
      }
      .msg {
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
      }
    }
    .empty_style {
      height: 500px;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-image {
        margin-bottom: 20px;
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      // .el-pagination .el-pager li {
      //     background: #00f;
      // }
    }
  }
  .detail_pic {
    width: 420px;
    height: 320px;
    .el-image {
      width: 100%;
      height: 300px;
    }
  }
  .detail_msg {
    margin-left: 20px;
    width: 240px;
    .title {
      font-size: 18px;
      color: #333;
    }
    .base {
      margin-top: 20px;
      font-size: 18px;
      color: #000;
    }
    .popular {
      margin: 20px 0 10px 0;
      font-size: 12px;
      color: #999;
      span {
        margin: 0 10px;
      }
      .icon:hover {
        cursor: pointer;
        color: red;
      }
      .is_collect {
        color: red;
      }
      .no_collect {
        color: #999;
      }
    }
    .popular2 {
      margin: 10px 0;
      font-size: 12px;
      color: #999;
    }

    .character {
      margin-bottom: 20px;
      font-size: 12px;
      color: #666;
      span {
        margin: 0 5px;
      }
    }
    .other {
      margin: 15px 0;
      :first-child {
        color: #999;
        font-size: 12px;
        margin-right: 10px;
      }
      :last-child {
        color: #666;
        font-size: 14px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
<style lang="scss">
.box_seach {
  .el-select {
    width: 100px;
    .el-input__inner {
      border: none;
    }
  }
}
// .file {
//   .el-collapse .el-collapse-item__header {
//     border: none;
//   }
// }
</style>
